module.exports = __webpack_public_path__ + "static/media/kamphuis field2.2cc2c8ab.jpeg";